export const zipCodeRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;

export const npiRegex = /^\d{10}$/;
